













import { Component, Vue } from 'vue-property-decorator';

@Component({
    props: ['data'],
})

export default class Forecast extends Vue {
    private data: any = this.data;
    private icon =  'Loading';
    private month = 'Loading';
    private day = 'Loading';
    private time = 0;

    ordinal_suffix_of(i: number) {
        let j = i % 10,
            k = i % 100;
        if (j == 1 && k != 11) {
            return i + "st";
        }
        if (j == 2 && k != 12) {
            return i + "nd";
        }
        if (j == 3 && k != 13) {
            return i + "rd";
        }
        return i + "th";
    }

    mounted() {
        const monthNames = ["January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December"
        ];
        let today = new Date(this.data.dt*1000);
        this.day = this.ordinal_suffix_of(today.getDate());
        this.month =  monthNames[today.getMonth()];
        this.time = today.getHours();
        this.icon = "https://openweathermap.org/img/wn/" +
       this.data.weather[0].icon +
        "@2x.png";

    }
};

